import * as React from "react";
import {Modal} from "web-com";
import "./styles.scss";
import {readableDateFormat} from "utils";

interface IPaymentConfirm {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  dueDate: Date;
}

const PaymentConfirmPopup = (props: IPaymentConfirm) => {
  return (
    <Modal 
      active={props.isOpen}
      onClose={() => props.onClose()}
      cancellable={true}
      submitTitle="I wish to pay"
      cancelTitle="Cancel"
      onSubmit={() => props.onSubmit()}>
        <div className="payment-confirm">
          <span>Dear Customer,</span>
          {`Please note that your NACH presentation for
            ${readableDateFormat(props.dueDate).slice(0, 3).concat(readableDateFormat(props.dueDate).slice(6, 11))}
            EMI is already under process. In case of any excess amount against your loan account, a refund will be processed.
          `}
        </div>
    </Modal>
  );
};

export default PaymentConfirmPopup;